// Generated by CoffeeScript 2.7.0
var EditCascadedSelectModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import LabelListItem from './label_list_item.js';

export default EditCascadedSelectModal = Vue.extend({
  components: {
    'modal': Modal,
    'label-list-item': LabelListItem
  },
  props: {
    title: {
      type: String
    },
    initialCascadedSelect: {
      type: Object
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    var ref;
    return {
      cascadedSelect: JSON.parse(JSON.stringify(this.initialCascadedSelect)),
      cascadedSelectName: ((ref = this.initialCascadedSelect) != null ? ref.name : void 0) || "",
      valid: true
    };
  },
  template: `<modal :title="title"
       extendClass="cascaded-select-modal"
       @ensureClicked="ensureClickedFunc"
       @cancelClicked="cancelClickedFunc"
       size='small'
       ref="cascadedSelectModalRef">
  <template>
    <div class="modal-body mt-5">
      <div class="form-field required"
           :class="{ 'has-error': !valid }">
        <div class="form-field-head mr-2">
          <div class="form-field-title">级联选择名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="form-field-value"
                   placeholder="请输入级联选择名称"
                   type="text"
                   v-model.trim="cascadedSelectName">
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
      <div class="form-field">
        <div class="form-field-head mr-2">
          <div class="form-field-title">级联选择层级</div>
        </div>
        <div class="form-field-input-container mt-3">
          <label-list-item v-for="(label,index) in cascadedSelect.labels"
                           :key="index"
                           :index="index"
                           :initialLabel="label"
                           @labelChanged="updateLabelFunc"
                           @deletedLabel="deletedLabelFunc" />
          <div class="content-centered inline mb-4">
            <button class="text-btn btn-primary" @click="addLabelFunc">
              <i class="slp-plus-circle"></i>
              <span>添加层级</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  methods: {
    ensureClickedFunc: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.cascadedSelectModalRef.open();
        return;
      }
      this.cascadedSelect.name = this.cascadedSelectName;
      return this.callback(this.cascadedSelect);
    },
    cancelClickedFunc: function() {
      return this.cascadedSelect = JSON.parse(JSON.stringify(this.initialCascadedSelect));
    },
    updateLabelFunc: function(index, val) {
      return this.cascadedSelect.labels[index] = val;
    },
    addLabelFunc: function() {
      return this.cascadedSelect.labels.push('新层级');
    },
    deletedLabelFunc: function(index) {
      if (this.cascadedSelect.labels.length === this.cascadedSelect.min_label_length) {
        return Skylark.Bridge.newAlertify(`请保留${this.cascadedSelect.min_label_length}个层级`, {
          type: 'error'
        });
      } else {
        return this.cascadedSelect.labels.splice(index, 1);
      }
    },
    _validate: function() {
      return this.valid = Boolean(this.cascadedSelectName);
    }
  }
});
